import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ItemPoolModel, PoolModel } from 'app/models/pool-model';
import { PriceModel } from 'app/models/price-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';


@Component({
  selector: 'app-admin-pool',
  templateUrl: './admin-pool.page.html',
  styleUrls: ['./admin-pool.page.scss'],
})
export class AdminPoolPage implements OnInit {

  displayedColumns: string[] = ['id', 'status', 'leasedFrom', 'leasedUntil'];
  dataSource = new MatTableDataSource<PoolModel>;

  constructor(
    private dialog: MatDialog,
    private restService: RestService,
    public appService: AppService
  ) { }

  ngOnInit() {
    this.getPools();
  }

  refresh() {
    this.getPools();
  }

  openDetails(pool?: PoolModel) {
    let dialogRef = this.dialog.open(PoolModalContent, {
      panelClass: 'responsive-dialog',
      data: { pool: pool }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.getPools());
  }

  getPools() {
    this.restService.getPools().subscribe(result => {
      this.dataSource = new MatTableDataSource(result);
    });
  }

  requestPool(): void {
    if (!confirm('¿Está seguro de realizar la acción?')) return;
    this.restService.requestPool().subscribe({
      next: (result) => {
        this.getPools();
      }
    });
  }

}




@Component({
  selector: 'app-pool-modal-content',
  templateUrl: './pool-modal.component.html',
  styleUrls: ['./pool-modal.component.scss']
})
export class PoolModalContent implements OnInit {

  displayedColumns: string[] = ['seq', 'boxId', 'consumedAt', 'reservationId', 'action'];
  dataSource = new MatTableDataSource<ItemPoolModel>;

  constructor(
    private restService: RestService,
    public appService: AppService,
    private dialogRef: MatDialogRef<PoolModalContent>,
    @Inject(MAT_DIALOG_DATA) public data: { pool: PoolModel }
  ) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data?.pool?.items);
  }



  close(): void {
    this.dialogRef.close();
  }


  consumePool(): void {
    if (!confirm('¿Está seguro de realizar la acción?')) return;
    this.restService.consumePool(this.data.pool.id).subscribe({
      next: (result) => {
        this.dialogRef.close({ updated: true });
      }
    });
  }

  consumeItemPool(itemId:number): void {
    if (!confirm('¿Está seguro de realizar la acción?')) return;
    this.restService.consumeItemPool(this.data.pool.id, itemId).subscribe({
      next: (result) => {
        this.dialogRef.close({ updated: true });
      }
    });
  }

  

}